import { render, staticRenderFns } from "./SvgSectionComponent.vue?vue&type=template&id=04167d2a"
import script from "./SvgSectionComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./SvgSectionComponent.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports